interface RemoteLockOutlineProps {
  width: number
  height: number
}

/** Dashed frame over a shape that another user has locked. */
export function RemoteLockOutline({ width, height }: RemoteLockOutlineProps) {
  return (
    <rect
      x={0}
      y={0}
      width={width}
      height={height}
      fill="none"
      stroke="var(--color-page-editor-lock)"
      strokeWidth={2}
      // Without it the remote-lock dashes thickened with zoom while every neighbouring outline held
      // its screen size (WMPCM-9868).
      vectorEffect="non-scaling-stroke"
      strokeDasharray="6 3"
      pointerEvents="none"
    />
  )
}
